import { render, staticRenderFns } from "./SalesOrderDetails.vue?vue&type=template&id=6f9f31fe&scoped=true&"
import script from "./SalesOrderDetails.vue?vue&type=script&lang=js&"
export * from "./SalesOrderDetails.vue?vue&type=script&lang=js&"
import style0 from "./SalesOrderDetails.vue?vue&type=style&index=0&id=6f9f31fe&prod&lang=scss&scoped=true&"
import style1 from "./SalesOrderDetails.vue?vue&type=style&index=1&id=6f9f31fe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9f31fe",
  null
  
)

export default component.exports